// React
import { useState, useEffect } from "react";

// OpenLayers
import OlMap from "ol/Map";

// jQuery
import $ from "jquery";

// Popups
import LocalesPopup from "views/popups/Locales";

// Models
import Locale from "lib/interfaces/locale";

// Tools
import { assetURL, getFlagAssetName } from "lib/utilities/asset";
import { getLocaleString } from "lib/localization/vendor";
import { getOffsetBottomPixels } from "lib/utilities/misc";

import "styles/css/LocalePicker.scss";

interface LocalePickerProps {
	olMap:OlMap
}

export default function LocalePicker({olMap}:LocalePickerProps) {
	const mapConfig:any = olMap.get("opus-config");
	const activeLocale:Locale = _config.lang.locale;
	
	const [currentLocale, setCurrentLocale] = useState<Locale>(activeLocale);
	
	// Initialize
	useEffect(() => {
		// Relies on #locale-picker being available
		setTimeout(() => adjust(), 100);
		setTimeout(() => adjust(), 250);
		setTimeout(() => adjust(), 500);
	}, [olMap]);
	
	// On dimensions changed
	useEffect(() => {
		adjust();
	}, [_dimensions]);
	
	// On language changed
	useEffect(() => {
		setCurrentLocale(_config.lang.locale);
	}, [_config.lang.locale]);
	
	const adjust = () => {
		const width:number = _dimensions.width;
		const height:number = _dimensions.height;
		
		if(width < 340)
			$("#locale-picker").fadeOut(_ui.transitionDownOptions);
		else
			$("#locale-picker").fadeIn(_ui.transitionUpOptions);
			
		const paddingLeft:number = ($("#base-map-switcher").position()?.left || 40) + (_dimensions.width > 400 ? 15 : 10);
		const left:number = $("#base-map-switcher").width() + paddingLeft;
		
		$("#locale-picker").css("left", left);
		
		const bmBottom:number = getOffsetBottomPixels("#base-map-switcher") + 30;
		
		if(bmBottom) {
			$("#locale-picker").css("bottom", (bmBottom-5) + "px");
		}
	}
	const getCountryId = ():string => {
		return getFlagAssetName(_config.lang.id) || "blank";
	}
	const getLangLabel = ():string => {
		return _config.lang.locale.name;
	}
	const onLocalePickerClicked = () => {
		LocalesPopup.set("map", olMap);
		
		_ui.showPopup(LocalesPopup);
	}
	
	// Don't show if less than 2 language options
	if(mapConfig.locales?.length < 2 || !mapConfig.locales)
		return null;
	
	return (
		<div id="locale-picker" className="locale-picker" onClick={onLocalePickerClicked}>
			<img 
				src={assetURL(`assets/images/flags/${getCountryId()}.png`)}
				className='flag' 
			/> 
			{getLangLabel()}
		</div>
	);
}